import React, { FC } from 'react';
import { styles } from './styles';
import { Typography } from 'fronton-react';
import { getFormattedOldPrice } from './utils';
import { TypographyProps } from 'fronton-react/typography/types';
import { cx } from 'linaria';

type Props = {
  price?: string;
  currency?: string;
  mini?: boolean;
  className?: string;
};

export const CrossedPrice: FC<Props> = ({ price, currency, mini, className }) => {
  const props: TypographyProps = mini
    ? {
        variant: 'mini',
        size: 'accent',
      }
    : {
        variant: 's',
        size: 'body_accent',
      };

  return (
    <div className={cx(mini ? styles.mini : null, styles.oldPriceCrossed, className)}>
      <Typography {...props} color="text-primary">
        {getFormattedOldPrice(price)}
      </Typography>
      <Typography
        {...props}
        color="text-primary"
        className={mini ? styles.oldCurrencyWrapMini : styles.oldCurrencyWrap}
      >
        {currency}
      </Typography>
    </div>
  );
};
